// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img/home/bg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home {
  flex: 1 1;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center top;
  padding: 36px 0 80px;
}
.home-container {
  width: 100%;
  max-width: 1212px;
  padding: 0 16px;
  margin: 0 auto;
}
@media (max-width: 1260px) and (min-width: 740px) {
  .home-container {
    max-width: 752px;
  }
}
@media (max-width: 740px) {
  .home-container {
    max-width: 320px;
  }
}
.home-header {
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
@media (max-width: 740px) {
  .home-header {
    margin-bottom: 24px;
  }
}
.home-header__logo {
  width: 124px;
  margin-right: 12px;
}
.home-header__title {
  font-weight: 700;
  font-size: 18px;
  line-height: 133%;
}
.home-table-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  border-bottom: 1px solid #828ea6;
}
@media (max-width: 740px) {
  .home-table-header {
    display: none;
  }
}
.home-table-header__col {
  font-size: 14px;
  line-height: 171%;
  font-weight: 600;
  font-weight: 800;
  color: #838da4;
}
.home-table-body {
  padding: 12px 0;
}`, "",{"version":3,"sources":["webpack://./src/features/home/home.scss","webpack://./src/sass/mixins/_grid.scss","webpack://./src/sass/mixins/_adaptive.scss","webpack://./src/sass/mixins/_typography.scss"],"names":[],"mappings":"AAGA;EACI,SAAA;EACA,wEAAA;EACA,oBAAA;AAFJ;AAII;ECLA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;ADIJ;AE6CI;EF/CA;ICAI,gBAAA;EDMN;AACF;AE8CI;EFrDA;ICGI,gBAAA;EDQN;AACF;AARI;EACI,aAAA;EACA,qBAAA;EACA,uBAAA;AAUR;AEoCI;EFjDA;IAKQ,mBAAA;EAYV;AACF;AAVQ;EACI,YAAA;EACA,kBAAA;AAYZ;AATQ;EGhBJ,gBAAA;EACA,eAAA;EACA,iBAAA;AH4BJ;AARQ;EACI,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,gCAAA;AAUZ;AEgBI;EF9BI;IAMQ,aAAA;EAYd;AACF;AAVY;EGzBR,eAAA;EACA,iBAAA;EACA,gBAAA;EAKA,gBAAA;EHoBY,cAAA;AAehB;AAXQ;EACI,eAAA;AAaZ","sourcesContent":["@import 'src/sass/common/variables';\n@import 'src/sass/mixins';\n\n.home {\n    flex: 1;\n    background: url(/assets/img/home/bg.svg) no-repeat center top;\n    padding: 36px 0 80px;\n\n    &-container {\n        @include container;\n    }\n\n    &-header {\n        display: flex;\n        align-items: flex-end;\n        justify-content: center;\n        @include mobile {\n            margin-bottom: 24px;\n        }\n\n        &__logo {\n            width: 124px;\n            margin-right: 12px;\n        }\n\n        &__title {\n            @include title1;\n        }\n    }\n\n    &-table {\n        &-header {\n            display: flex;\n            align-items: flex-end;\n            justify-content: space-between;\n            border-bottom: 1px solid #828ea6;\n            @include mobile {\n                display: none;\n            }\n\n            &__col {\n                @include caption;\n                color: #838da4;\n            }\n        }\n\n        &-body {\n            padding: 12px 0;\n        }\n    }\n}\n","@import 'src/sass/common/variables';\n\n@mixin container {\n    width: 100%;\n    max-width: calc($container + $indentSmall * 2);\n    padding: 0 $indentSmall;\n    margin: 0 auto;\n    @include tablet {\n        max-width: calc($containerTablet + $indentSmall * 2);\n    }\n    @include mobile {\n        max-width: calc($containerMobile + $indentSmall * 2);\n    }\n}","@import 'src/sass/common/variables';\n\n@mixin media($min-width: false, $max-width: false) {\n    @if $min-width and $max-width {\n        @media screen and (min-width: $min-width) and (max-width: $max-width) {\n            @content;\n        }\n    } @else if $min-width and not $max-width {\n        @media screen and (min-width: $min-width) {\n            @content;\n        }\n    } @else if $max-width and not $min-width {\n        @media screen and (max-width: $max-width) {\n            @content;\n        }\n    }\n}\n\n@mixin fullhd {\n    @media (min-width: #{$large}) {\n        @content;\n    }\n}\n\n@mixin desktop {\n    @media (min-width: #{$medium}) {\n        @content;\n    }\n}\n\n@mixin desktop-tablet {\n    @media (min-width: #{$small}) {\n        @content;\n    }\n}\n\n@mixin laptop {\n    @media (max-width: #{$large}) and (min-width: #{$medium}) {\n        @content;\n    }\n}\n\n@mixin laptop-tablet {\n    @media (max-width: #{$large}) and (min-width: #{$small}) {\n        @content;\n    }\n}\n\n@mixin laptop-mobile {\n    @media (max-width: #{$large}) {\n        @content;\n    }\n}\n\n@mixin tablet {\n    @media (max-width: #{$medium}) and (min-width: #{$small}) {\n        @content;\n    }\n}\n\n@mixin mobile {\n    @media (max-width: #{$small}) {\n        @content;\n    }\n}\n\n@mixin tablet-mobile {\n    @media (max-width: #{$medium}) {\n        @content;\n    }\n}","@import 'src/sass/common/variables';\n\n@mixin h4 {\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 133%;\n}\n\n@mixin title1 {\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 133%;\n}\n\n@mixin body1 {\n    font-size: 14px;\n    line-height: 171%;\n    font-weight: 600;\n}\n\n@mixin caption {\n    @include body1;\n    font-weight: 800;\n}\n\n@mixin textWithDots {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
